// Tipos de acuerdos posibles
export enum TipoAcuerdo {
  LIBRE = 'libre', // [acuerdo_libre - no esta en uso actualmente]
  CONSORCIO = 'consorcio',
  ADMINISTRACION = 'administracion',
}

// Tipos de consorcios
export enum TipoConsorcio {
  EDIFICIO = 'edificio',
  BARRIO = 'barrio',
}

// Caminos para la creación de acuerdos para consorcios pendientes
export enum TipoCreacionPendientes {
  CREAR_DESDE_CERO = 0,
  USAR_ACUERDO_POR_DEFECTO_ADMIN = 1,
}

// Acciones posibles a realizar sobre un acuerdo comercial
export enum AccionesSobreAcuerdosComerciales {
  DETALLES = 'detalles',
  HISTORIAL = 'historial',
  EDITAR = 'editar',
  EXTENDER_TIEMPO = 'extender',
  FINALIZAR_PERIODO_ACEPTACION = 'finalizar_trial',
  ELIMINAR = 'eliminar'
}

// Tipos de estados del acuerdo comercial
export enum TiposEstadosAcuerdoComercial {
  NUEVA = 'nueva',
  RECHAZADA = 'rechazada',
  RENEGOCIADA = 'renegociada',
  ACEPTADA = 'aceptada',
  ACTUALIZADA = 'actualizada',
  FACTURANDO = 'facturando',
  ARCHIVADA = 'archivada',
  EXPIRADO = 'expirada',
  PERIODO_ACEPTACION_FINALIZADO_POR_AGENTE = 'trial_finalizado',
  ADMINISTRACION = 'administracion',
  ACTIVACION = 'activacion',
  EXTENDIDO = 'extendido',
}

// Origen de los acuerdos comerciales
export enum OrigenAcuerdoComercial {
  MAS_CONSORCIOS = '+consorcios',
  AUTOMATICA = 'automatica',
  MANUAL = 'manual',
}

// Tabs de layout
export const TAB_NUEVOS_CONSORCIOS = 0;
export const TAB_ACUERDOS_EN_CURSO = 1;
export const TAB_BUSCADOR = 2;

// Acciones ABM
export const VISUALIZAR = 'visualizar';
export const EDITAR = 'editar';
export const ELIMINAR = 'eliminar';
export const EXTENDER_TIEMPO = 'extender';
export const FINALIZAR_PERIODO_ACEPTACION = 'finalizar_periodo_aceptacion';

// Se usa esta constante como caso default para el minimo de ufs permitidas en la plataforma
export const MINIMO_UFS_PERMITIDAS = 20;

// Patrón de caminos/estados
// Vistas / Estados del sidesheet
export const VISTA_SELECCION_PLANTILLA_PERSONALIZADA = 'Vista de seleccion de plantilla personalizada';
export const VISTA_SELECCION_ADMINISTRACION = 'Vista de selección de la administracion';
export const VISTA_SELECCION_CONSORCIOS = 'Vista de selección de consorcios';
export const VISTA_CREACION_ACUERDO = 'Vista de creación de acuerdo';
export const VISTA_EDICION_ACUERDO = 'Vista de edición de acuerdo';
export const VISTA_PREVIA = 'Vista previa';
export const EJECUTAR_CREACION_AC = 'Ejecutar creación de acuerdo comercial';
export const FINALIZAR_OPERACION = 'Finalizar operación';

// Posibles caminos del acuerdo comercial (flujo entre las vistas del sidesheet)
export const CAMINO_ACUERDO_LIBRE = [
  VISTA_SELECCION_PLANTILLA_PERSONALIZADA,
  VISTA_CREACION_ACUERDO,
  VISTA_PREVIA,
  EJECUTAR_CREACION_AC,
  FINALIZAR_OPERACION
];

export const CAMINO_ACUERDO_POR_DEFECTO = [
  VISTA_SELECCION_ADMINISTRACION,
  VISTA_CREACION_ACUERDO,
  VISTA_PREVIA,
  EJECUTAR_CREACION_AC,
  FINALIZAR_OPERACION
];

export const CAMINO_ACUERDO_VINCULADO_A_CONSORCIOS = [
  VISTA_SELECCION_CONSORCIOS,
  VISTA_SELECCION_PLANTILLA_PERSONALIZADA,
  VISTA_CREACION_ACUERDO,
  VISTA_PREVIA,
  EJECUTAR_CREACION_AC,
  FINALIZAR_OPERACION
];

export const CAMINO_ACUERDO_VINCULADO_A_CONSORCIOS_PENDIENTES = [
  VISTA_SELECCION_PLANTILLA_PERSONALIZADA,
  VISTA_CREACION_ACUERDO,
  VISTA_PREVIA,
  EJECUTAR_CREACION_AC,
  FINALIZAR_OPERACION
];

export const CAMINO_ACUERDO_VINCULADA_A_CONSORCIOS_PENDIENTES_USANDO_ACUERDO_ADMINISTRACION = [
  VISTA_PREVIA,
  EJECUTAR_CREACION_AC,
  FINALIZAR_OPERACION
];

export const CAMINO_EDICION_ACUERDO_COMERCIAL = [
  VISTA_EDICION_ACUERDO,
  VISTA_PREVIA
];

export const TIPO_CONSORCIO_EDIFICIO =  { key: TipoConsorcio.EDIFICIO, titulo: 'Edificio' };
export const TIPO_CONSORCIO_BARRIO =  { key: TipoConsorcio.BARRIO, titulo: 'Barrio' };
export const TIPOS_CONSORCIO = [TIPO_CONSORCIO_EDIFICIO, TIPO_CONSORCIO_BARRIO];

export function getTituloTipoConsorcio(key: string) {
  return TIPOS_CONSORCIO.find(x => x.key === key)?.titulo ?? key;
}

// Tipos de filtros para el primer nivel del tab buscador
export const FILTRO_TAB_BUSCADOR_DE_UNA_ADMINISTRACION = {text: 'De una administración', value: 0};
export const FILTRO_TAB_BUSCADOR_DE_CONSORCIOS = {text: 'De consorcios', value: 1};
export const FILTRO_TAB_BUSCADOR_POR_DEFECTO = {text: 'Por defecto', value: 2};
export const FILTROS_TAB_BUSCADOR = [FILTRO_TAB_BUSCADOR_DE_UNA_ADMINISTRACION, FILTRO_TAB_BUSCADOR_DE_CONSORCIOS, FILTRO_TAB_BUSCADOR_POR_DEFECTO];

// Tipos de busqueda de acuerdo comercial para enviar a la API de acuerdos comerciales
export const TIPO_BUSQUEDA_ACUERDO_COMERCIAL_ADMINISTRACION = 'administracion';
export const TIPO_BUSQUEDA_ACUERDO_COMERCIAL_CONSORCIOS = 'consorcio';
export const TIPO_BUSQUEDA_ACUERDO_COMERCIAL_POR_DEFECTO = 'por_defecto';

// Estados terminadores (estados en los cuales ya no es posible realizar modificaciones en el acuerdo comercial)
export const ESTADO_ACUERDO_COMERCIAL_TERMINADORES = [TiposEstadosAcuerdoComercial.FACTURANDO, TiposEstadosAcuerdoComercial.ACEPTADA];

// Se declaran también con constantes separadas para agregar el formateo con el texto y su plural
export const ESTADO_ACUERDO_COMERCIAL_NUEVA = {key: TiposEstadosAcuerdoComercial.NUEVA, texto: 'Nuevo', label_plural: 'Nuevos'};
export const ESTADO_ACUERDO_COMERCIAL_RECHAZADA = {key: TiposEstadosAcuerdoComercial.RECHAZADA, texto: 'Contactar cliente', label_plural: 'Contactar clientes'};
export const ESTADO_ACUERDO_COMERCIAL_RENEGOCIADA = {key: TiposEstadosAcuerdoComercial.RENEGOCIADA, texto: 'Renegociado', label_plural: 'Renegociados'};
export const ESTADO_ACUERDO_COMERCIAL_ACEPTADA = {key: TiposEstadosAcuerdoComercial.ACEPTADA, texto: 'Aceptado', label_plural: 'Aceptados'};
export const ESTADO_ACUERDO_COMERCIAL_ACTUALIZADA = {key: TiposEstadosAcuerdoComercial.ACTUALIZADA, texto: 'Actualizado', label_plural: 'Actualizados'};
export const ESTADO_ACUERDO_COMERCIAL_FACTURANDO = {key: TiposEstadosAcuerdoComercial.FACTURANDO, texto: 'Facturando', label_plural: 'Facturando'};
export const ESTADO_ACUERDO_COMERCIAL_ARCHIVADA = {key: TiposEstadosAcuerdoComercial.ARCHIVADA, texto: 'Archivado'};
export const ESTADO_ACUERDO_COMERCIAL_EXPIRADO = {key: TiposEstadosAcuerdoComercial.EXPIRADO, texto: 'Expirado', label_plural: 'Expirados'};
export const ESTADO_ACUERDO_COMERCIAL_ADMINISTRACION = {key: TiposEstadosAcuerdoComercial.ADMINISTRACION, texto: 'Acuerdo de la administración'};
export const ESTADOS_ACUERDO_COMERCIAL_FORMATEADOS = [ESTADO_ACUERDO_COMERCIAL_NUEVA, ESTADO_ACUERDO_COMERCIAL_RECHAZADA, ESTADO_ACUERDO_COMERCIAL_RENEGOCIADA, ESTADO_ACUERDO_COMERCIAL_ACEPTADA, ESTADO_ACUERDO_COMERCIAL_ACTUALIZADA, ESTADO_ACUERDO_COMERCIAL_FACTURANDO, ESTADO_ACUERDO_COMERCIAL_ARCHIVADA, ESTADO_ACUERDO_COMERCIAL_ADMINISTRACION, ESTADO_ACUERDO_COMERCIAL_EXPIRADO
];

// Estados posibles para el filtrado en las tablas donde se visualicen acuerdos comerciales
export const ESTADOS_FILTRABLES_PARA_TABLA_ACUERDOS_COMERCIALES = [
  ESTADO_ACUERDO_COMERCIAL_NUEVA,
  ESTADO_ACUERDO_COMERCIAL_ACEPTADA,
  ESTADO_ACUERDO_COMERCIAL_ACTUALIZADA,
  ESTADO_ACUERDO_COMERCIAL_FACTURANDO
];

/**
 * Retorna el titulo del estado del acuerdo comercial en base a su key 
 */
export function getTituloEstadoAcuerdoComercial(key: string) {
  return ESTADOS_ACUERDO_COMERCIAL_FORMATEADOS.find(x => x.key === key)?.texto ?? key;
}
